import { useEffect, useRef, useState } from 'react';

import { pollTask } from 'js/utils/usher';

import { ImpactStats } from './types';

type ColdStartFields = {
  citations: number;
  citationsTrendPct: number | null;
};

export function useCitationsColdStart(
  impactStats: ImpactStats | null | undefined,
  userId: number | null | undefined,
): ImpactStats | null | undefined {
  const [coldStartFields, setColdStartFields] =
    useState<ColdStartFields | null>(null);
  const invoked = useRef(false);

  const citationsCold = impactStats != null && impactStats.citations == null;

  useEffect(() => {
    if (!citationsCold || userId == null || invoked.current) {
      return;
    }
    invoked.current = true;
    pollTask('nav_citation_stats', userId)
      .then((result) => setColdStartFields(result))
      .catch(() => undefined);
  }, [citationsCold, userId]);

  if (impactStats == null || impactStats.citations != null) {
    return impactStats;
  }
  if (coldStartFields == null) {
    return impactStats;
  }
  return { ...impactStats, ...coldStartFields };
}
